/* eslint-disable */
import * as React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {
  Route,
  Routes,
  Link,
  // MemoryRouter,
  matchPath,
  useLocation
} from 'react-router-dom';
import TransactionInApp from './paymentgateway';
import ManualTransaction from './manual';

// function Router(props) {
//   const { children } = props;
//   if (typeof window === 'undefined') {
//     return <StaticRouter location="/transaction/in-app">{children}</StaticRouter>;
//   }

//   return (
//     <MemoryRouter initialEntries={['/transaction/in-app']} initialIndex={0}>
//       {children}
//     </MemoryRouter>
//   );
// }

// Router.propTypes = {
//   children: PropTypes.node,
// };

function useRouteMatch(patterns) {
  const { pathname } = useLocation();

  for (let i = 0; i < patterns.length; i += 1) {
    const pattern = patterns[i];
    const possibleMatch = matchPath(pattern, pathname);
    if (possibleMatch !== null) {
      return possibleMatch;
    }
  }

  return null;
}

function MyTabs() {
  // You need to provide the routes in descendant order.
  // This means that if you have nested routes like:
  // users, users/new, users/edit.
  // Then the order should be ['users/add', 'users/edit', 'users'].
  const routeMatch = useRouteMatch(['/transaction/in-app', '/transaction/manual']);
  const currentTab = routeMatch?.pattern?.path;

  return (
    <Tabs value={currentTab} sx={{ mb: 3 }}>
      <Tab
        label="Payment Gateway"
        value="/transaction/in-app"
        to="/transaction/in-app"
        component={Link}
      />
      <Tab label="Manual" value="/transaction/manual" to="/transaction/manual" component={Link} />
    </Tabs>
  );
}

export default function Transaction() {
  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      <div className="pageTitleWrap">
        <Typography className="" component="h2" variant="h2">
          Transactions
        </Typography>
      </div>
      <Box className="tabWrapper" sx={{ width: '100%', typography: 'body1' }}>
        <MyTabs />
        <Routes>
          <Route path="/in-app" element={<TransactionInApp />} />
          <Route path="/manual" element={<ManualTransaction />} />
        </Routes>
      </Box>
    </Box>
  );
}
